import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/lib/theme";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileStickyCTA, BackToTop } from "@/components/FloatingCTAs";
import { ScrollToTop } from "@/components/ScrollToTop";
import { SiteProvider } from "@/lib/site";

import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProgramsPage from "@/pages/ProgramsPage";
import ProgramDetailPage from "@/pages/ProgramDetailPage";
import CampaignsPage from "@/pages/CampaignsPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import DonatePage from "@/pages/DonatePage";
import VolunteerPage from "@/pages/VolunteerPage";
import ReportIssuePage from "@/pages/ReportIssuePage";
import ContactPage from "@/pages/ContactPage";
import CSRPage from "@/pages/CSRPage";
import TransparencyPage from "@/pages/TransparencyPage";
import TeamPage from "@/pages/TeamPage";
import FAQPage from "@/pages/FAQPage";
import AnnualReportsPage from "@/pages/AnnualReportsPage";
import PolicyPage from "@/pages/PolicyPage";
import AdminPage from "@/pages/AdminPage";
import NotFoundPage from "@/pages/NotFoundPage";
// v2 pages
import GovernancePage from "@/pages/GovernancePage";
import GrievanceRedressalPage from "@/pages/GrievanceRedressalPage";
import MembershipPage from "@/pages/MembershipPage";
import EventsPage from "@/pages/EventsPage";
import PressReleasesPage from "@/pages/PressReleasesPage";
import VideoLibraryPage from "@/pages/VideoLibraryPage";
import MediaCentrePage from "@/pages/MediaCentrePage";
import VolunteerStoriesPage from "@/pages/VolunteerStoriesPage";
import TrainingPage from "@/pages/TrainingPage";
import YouthVoicePage from "@/pages/YouthVoicePage";
import { AwarenessHubPage, AwarenessTopicPage } from "@/pages/AwarenessPages";
import ReceiptPage from "@/pages/ReceiptPage";
import DonorWallPage from "@/pages/DonorWallPage";

function App() {
  return (
    <ThemeProvider>
      <SiteProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/programs/:slug" element={<ProgramDetailPage />} />
            <Route path="/campaigns" element={<CampaignsPage />} />
            <Route path="/campaigns/:slug" element={<CampaignsPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/receipt/:id" element={<ReceiptPage />} />
            <Route path="/donor-wall" element={<DonorWallPage />} />
            <Route path="/volunteer" element={<VolunteerPage />} />
            <Route path="/report-issue" element={<ReportIssuePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/csr" element={<CSRPage />} />
            <Route path="/transparency" element={<TransparencyPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/annual-reports" element={<AnnualReportsPage />} />
            {/* Compliance */}
            <Route path="/governance" element={<GovernancePage />} />
            <Route path="/grievance-redressal" element={<GrievanceRedressalPage />} />
            <Route path="/privacy" element={<PolicyPage slug="privacy" />} />
            <Route path="/terms" element={<PolicyPage slug="terms" />} />
            <Route path="/refund-policy" element={<PolicyPage slug="refund" />} />
            <Route path="/donation-policy" element={<PolicyPage slug="donation" />} />
            <Route path="/accessibility" element={<PolicyPage slug="accessibility" />} />
            <Route path="/child-protection" element={<PolicyPage slug="child-protection" />} />
            <Route path="/volunteer-policy" element={<PolicyPage slug="volunteer-policy" />} />
            <Route path="/code-of-ethics" element={<PolicyPage slug="code-of-ethics" />} />
            <Route path="/conflict-of-interest" element={<PolicyPage slug="conflict-of-interest" />} />
            {/* v2 engage/media */}
            <Route path="/membership" element={<MembershipPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/press-releases" element={<PressReleasesPage />} />
            <Route path="/video-library" element={<VideoLibraryPage />} />
            <Route path="/media" element={<MediaCentrePage />} />
            <Route path="/volunteer-stories" element={<VolunteerStoriesPage />} />
            <Route path="/training" element={<TrainingPage />} />
            <Route path="/youth-voice" element={<YouthVoicePage />} />
            <Route path="/awareness" element={<AwarenessHubPage />} />
            <Route path="/awareness/:slug" element={<AwarenessTopicPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Footer />
          <MobileStickyCTA />
          <BackToTop />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </div>
      </SiteProvider>
    </ThemeProvider>
  );
}

export default App;
